<template>
    <div class="collonsinputs">
        
        <vs-row vs-justify="center" class="ml-3 mr-3">
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card>
                    <div slot="header" class="w-full text-center">
                        <h4 class="text-primary">Esta seção é exclusiva para lojas com segmento farmacêutico.</h4>
                        <div style="text-align: center;">
                            <vx-tooltip
                                delay=".2s"
                                color="gray"
                                id="tooltip"
                                position="bottom"
                                text="Torna-se exclusiva para farmácias, pois apenas elas podem fornecer informações essenciais, como licenças, autorizações e detalhes sobre profissionais responsáveis, necessários para operar legalmente. Essas informações garantem conformidade com regulamentações, assegurando a qualidade e segurança dos produtos e serviços."
                            >
                                <feather-icon icon="AlertTriangleIcon" svgClasses="w-10 h-9 mt-3 text-primary"></feather-icon>
                            </vx-tooltip>
                        </div>
                    </div>
                </vs-card>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card>
                    <div slot="header" class="w-full flex justify-between">
                        <h3>
                            Sobre a Loja:
                        </h3>
                        <vx-tooltip
                            delay=".2s"
                            color="gray"
                            id="tooltip"
                            position="bottom"
                            text="Nessa seção irá tratar de informações essenciais como nome fantasia, razão social, CNPJ e descrição sobre a empresa. Esses detalhes são fundamentais para identificar e comunicar a identidade e o propósito da empresa aos clientes."
                        >
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                        </vx-tooltip>
                    </div>
                    <div>
                        <div class="spacing">
                            <span>Nome Fantasia:</span>
                            <vs-input
                                type="text"
                                v-model="company_name"
                                placeholder="Digite o Nome Fantasia"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Razão Social:</span>
                            <vs-input
                                type="text"
                                v-model="corporate_name"
                                placeholder="Digite a Razão Social"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>CNPJ:</span>
                            <vs-input
                                type="text"
                                v-mask="'##.###.###/####-##'"
                                v-model="document"
                                placeholder="Digite o CNPJ"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Sobre Nós:</span>
                            <vs-input
                                type="text"
                                v-model="about_us"
                                placeholder="Digite uma biografia da empresa"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Usuário Facebook:</span>
                            <vs-input
                                type="text"
                                v-model="nickname_facebook"
                                placeholder="Digite o nickname do facebook da empresa"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Usuário Instagram:</span>
                            <vs-input
                                type="text"
                                v-model="nickname_instagram"
                                placeholder="Digite o nickname do instagram da empresa"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                    </div>
                </vs-card>
                <vs-card>
                    <div slot="header" class="w-full flex justify-between">
                        <h4>
                            Telefone e Horário de Funcionamento:
                        </h4>
                        <vx-tooltip
                            delay=".2s"
                            color="gray"
                            id="tooltip"
                            position="bottom"
                            text="Nessa seção irá tratar de informações sobre comunicação e horário de atendimento, será submetido a inserção de telefone de contato e o horário de funcionamento da empresa. Essas informações são cruciais para fornecer aos clientes meios de contato direto e para que saibam quando podem contatar a empresa."
                        >
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                        </vx-tooltip>
                    </div>
                    <div>
                        <div class="spacing">
                            <span>Horário de Funcionamento:</span>
                            <vs-input
                                type="text"
                                v-mask="'##:## - ##:##'"
                                v-model=" working_hours"
                                placeholder="Das XX:XX as XX:XX"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Telefone:</span>
                            <vs-input
                                type="text"
                                v-mask="'+55 (##) #####-####'"
                                v-model="phone_number"
                                placeholder="Digite o Telefone"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>

        <vs-row class="ml-3 mr-3">
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card>
                    <div slot="header" class="w-full flex justify-between">
                        <h3>
                            Sobre a Loja:
                        </h3>
                        <vx-tooltip
                            delay=".2s"
                            color="gray"
                            id="tooltip"
                            position="bottom"
                            text="Nesta seção, são fornecidos detalhes abrangentes sobre a localização da loja, incluindo o CEP, endereço completo, número, complemento, bairro, cidade e estado. Essas informações são fundamentais para que os clientes possam encontrar facilmente a loja física, possibilitando uma experiência de compra presencial mais conveniente e eficiente."
                        >
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                        </vx-tooltip>
                    </div>
                    <div>
                        <div class="spacing">
                            <span>CEP:</span>
                            <vs-input
                                type="text"
                                v-mask="'#####-###'"
                                v-model="address_zip_code"
                                @input="screenCep"
                                placeholder="Digite o CEP"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Endereço:</span>
                            <vs-input
                                type="text"
                                v-model="address_street"
                                placeholder="Digite o Endereço"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Número:</span>
                            <vs-input
                                type="text"
                                v-model="address_number"
                                placeholder="Digite o Número do Endereço"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Complemento:</span>
                            <vs-input
                                type="text"
                                v-model="address_complement"
                                placeholder="Digite o Complemento"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Bairro:</span>
                            <vs-input
                                type="text"
                                v-model="address_neighbourhood"
                                placeholder="Digite o Bairro"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Cidade:</span>
                            <vs-input
                                type="text"
                                v-model="address_city"
                                placeholder="Digite a Cidade"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Estado:</span>
                            <vs-input
                                type="text"
                                v-model="address_state"
                                placeholder="Digite o Estado"
                                class="mb-3"
                                primary
                                v-validate="'required'"
                            />
                        </div>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>

        <vs-row vs-justify="center" class="ml-3 mr-3">
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card>
                    <div slot="header" class="w-full flex justify-between">
                        <h3>
                            Licenças e Autorizações:
                        </h3>
                        <vx-tooltip
                            delay=".2s"
                            color="gray"
                            id="tooltip"
                            position="bottom"
                            text="Nesta seção, são registradas todas as licenças e autorizações necessárias para operar a empresa, incluindo o nome e número de inscrição do farmacêutico responsável, o responsável técnico, licenças ou alvarás sanitários emitidos pelo órgão Estadual ou Municipal de Vigilância Sanitária, além de autorizações como AFE, AE e autorização especial de funcionamento. Essas informações garantem que a empresa esteja em conformidade com todas as regulamentações e requisitos legais, assegurando a qualidade e segurança dos produtos e serviços oferecidos."
                        >
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                        </vx-tooltip>
                    </div>
                    <div>
                        <div class="spacing">
                            <span>Nome e Número de Inscrição no Conselho do Farmacêutico Responsável Técnico:</span>
                            <vs-input
                                type="text"
                                v-model="document_crft"
                                class="inputswidth"
                                placeholder="Digite aqui..."
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Licença ou Alvará Sanitário expedido pelo órgão Estadual ou Municipal de Vigilância Sanitária:</span>
                            <vs-input
                                type="text"
                                v-model="document_vigilance_sanitary"
                                class="inputswidth"
                                placeholder="Digite aqui..."
                                primary
                                v-validate="'required'"
                                
                            />
                        </div>
                        <div class="spacing">
                            <span>Autorização de Funcionamento de Empresa (AFE) E AE:</span>
                            <vs-input
                                type="text"
                                v-model="document_ae"
                                class="inputswidth"
                                placeholder="Digite aqui..."
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing">
                            <span>Autorização Especial de Funcionamento:</span>
                            <vs-input
                                type="text"
                                v-model="document_afe"
                                class="inputswidth"
                                placeholder="Digite aqui..."
                                primary
                                v-validate="'required'"
                            />
                        </div>
                        <div class="spacing flex">
                            <span style="font-size: 1.2rem; font-weight: bold;">Anvisa</span>
                            <vx-tooltip
                                delay=".2s"
                                color="gray"
                                id="tooltip"
                                position="bottom"
                                text="A licença exclusiva emitida pela Anvisa (Agência Nacional de Vigilância Sanitária). Essa licença é fundamental para operar na indústria farmacêutica ou em atividades relacionadas à saúde, garantindo que a empresa atende aos rigorosos padrões de qualidade e segurança estabelecidos pela agência reguladora nacional."
                            >
                                <feather-icon icon="AlertCircleIcon" svgClasses="w-10 h-9 text-warning"></feather-icon>
                            </vx-tooltip>
                            <br/>
                        </div>
                        <p>Acesse para mais informações: <a target="_blank" href="https://www.gov.br/anvisa/pt-br">Agência Nacional de Vigilância Sanitária - Anvisa</a></p>
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>

        <vs-row vs-justify="center" class="ml-3 mr-3">
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card>
                    <div slot="header">
                        <h3>
                            Logo:
                        </h3>
                    </div>
                    <div>
                        <div>
                            <span>Caso deseja trocar a imagem, faça um novo upload!</span>
                            <div class="mb-8 image-items-card">
                                <div class="vx-col">
                                    <upload
                                    :action="uploadApiUrl"
                                    fileName="file"
                                    :headers="{
                                        Authorization: 'Bearer ' + bearer
                                    }"
                                    text="Escolher Arquivo"
                                    automatic
                                    :limit="1"
                                    :single-upload="true"
                                    @on-success="successUploadImage"
                                    @on-error="errorUploadImage"
                                    @on-delete="deleteUploadImage"
                                    />
                                </div>
                            </div>
                        </div>
                        <div>
                            <img :src='`${logo}`' class="image" v-if="logo!==''"/>
                        </div>
                    </div>
                </vs-card>

                <div class="text-center">
                    <vs-button @click.prevent="saveForm()">
                        Salvar
                    </vs-button>
                    <vs-button class="ml-6" type="border" color="danger" @click="cancelForm">
                        Limpar
                    </vs-button>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Upload from '@/components/upload/Upload'
import tenantInfo from '@/http/requests/tenantInfo'
import clientCep from '@/http/requests/tenantInfo/cep.js'

export default {
    name: "configs-client-form",
    components: { Upload },
    data() {
        return {
            logo: '',
            document: '',
            about_us: '',
            document_ae: '',
            company_name: '',
            document_afe: '',
            phone_number: '',
            address_city: '',
            address_state: '',
            working_hours: '',
            document_crft: '',
            corporate_name: '',
            address_street: '',
            address_number: '',
            address_zip_code: '',
            nickname_facebook: '',
            nickname_instagram: '',
            address_complement: '',
            address_neighbourhood: '',
            document_vigilance_sanitary: ''
        }
    },

    created() {
        tenantInfo.fetch().then((response) => {
            this.logo = response.data.data.tenantInfos[0].logo
            this.document = response.data.data.tenantInfos[0].document
            this.about_us = response.data.data.tenantInfos[0].about_us
            this.document_ae = response.data.data.tenantInfos[0].document_ae
            this.company_name = response.data.data.tenantInfos[0].company_name
            this.document_afe = response.data.data.tenantInfos[0].document_afe
            this.phone_number = response.data.data.tenantInfos[0].phone_number
            this.address_city = response.data.data.tenantInfos[0].address_city
            this.address_state = response.data.data.tenantInfos[0].address_state
            this.working_hours = response.data.data.tenantInfos[0].working_hours
            this.document_crft = response.data.data.tenantInfos[0].document_crft
            this.corporate_name = response.data.data.tenantInfos[0].corporate_name
            this.address_street = response.data.data.tenantInfos[0].address_street
            this.address_number = response.data.data.tenantInfos[0].address_number
            this.address_zip_code = response.data.data.tenantInfos[0].address_zip_code
            this.nickname_facebook = response.data.data.tenantInfos[0].nickname_facebook
            this.nickname_instagram = response.data.data.tenantInfos[0].nickname_instagram
            this.address_complement = response.data.data.tenantInfos[0].address_complement
            this.address_neighbourhood = response.data.data.tenantInfos[0].address_neighbourhood
            this.document_vigilance_sanitary = response.data.data.tenantInfos[0].document_vigilance_sanitary
        })
    },

    methods: {
        saveForm() {
            this.$validator.validateAll().then((response) => {
                if (!response) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Está faltando algo!',
                        text: 'Sentimos muito, está faltando informações para ser salvas!'
                    })

                    return;
                }

                tenantInfo.createTenantInfo({
                    logo: this.logo,
                    document: this.document,
                    about_us: this.about_us,
                    document_ae: this.document_ae,
                    company_name: this.company_name,
                    document_afe: this.document_afe,
                    phone_number: this.phone_number,
                    address_city: this.address_city,
                    address_state: this.address_state,
                    working_hours: this.working_hours,
                    document_crft: this.document_crft,
                    corporate_name: this.corporate_name,
                    address_street: this.address_street,
                    address_number: this.address_number,
                    address_zip_code: this.address_zip_code,
                    nickname_facebook: this.nickname_facebook,
                    nickname_instagram: this.nickname_instagram,
                    address_complement: this.address_complement,
                    address_neighbourhood: this.address_neighbourhood,
                    document_vigilance_sanitary: this.document_vigilance_sanitary,
                }).then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Informações salvas com sucesso!'
                    })
                }).catch(() => { 
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Ocorreu um erro ao enviar os dados!',
                        text: 'Sentimos muito, um erro ocorreu, por favor, nos contate para corrigir!'
                    })
                })
            })
    },
    screenCep(e) {
        let loadedCep = clientCep.showCep(e)
        if (loadedCep) {
            loadedCep.then(response => {
                return response.json()
            }).then(response => {
                this.address_city = response.localidade
                this.address_state = response.uf
                this.address_street = response.logradouro
                this.address_neighbourhood = response.bairro
                this.address_complement = response.complemento
            })
        }
        
    },

    deleteUploadImage() {
        this.image_url = null
        this.logo = ''
    },
    errorUploadImage(response) {
        this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um erro ao subir o arquivo!',
          text: response.data.message
        })
    },
    successUploadImage(response) {
        this.$vs.notify({
          color: 'success',
          title: 'Arquivo carregado com sucesso!',
          text: 'Imagem salva com sucesso!'
    })
        this.logo = response.data.fileUrl
      },
        cancelForm() {
            this.logo = ''
            this.image_url = null
            this.document = ''
            this.about_us = ''
            this.document_ae = ''
            this.company_name = ''
            this.document_afe = ''
            this.phone_number = ''
            this.address_city = ''
            this.address_state = ''
            this.working_hours = ''
            this.document_crft = ''
            this.corporate_name = ''
            this.address_street =  ''
            this.address_number = ''
            this.address_zip_code = ''
            this.nickname_facebook = ''
            this.nickname_instagram = ''
            this.address_complement = ''
            this.address_neighbourhood = ''
            this.document_vigilance_sanitary = ''
        }
    },

    computed: {
        uploadApiUrl() {
            return localStorage.getItem('baseUrl') + '/api/file/upload'
        },
        bearer() {
            return this.$store.state.auth.bearer
        },
    }
}
</script>

<style>
    .collonsinputs{
        display: flex;
    }
    .collonsinputs input {
        margin-bottom: 8px;
        min-width: 100%;
    }
    .vs-component.vs-con-input-label.vs-input.mb-3.vs-input-primary.is-label-placeholder {
        margin: 0px !important;
    }
    .spacing {
        margin: 10px 3px 10px 3px;
    }
    .image{
        width: 200px;
        height: 200px;
        margin-left: 10%;
    }
    @media (max-width: 1047px) {
        .collonsinputs {
            overflow: auto;
        }
    }
    @media (max-width: 670px) {
        .collonsinputs {
            display: block;
            overflow: unset;
        }
    }
</style>